export default class AbortError extends Error {
    public statusCode: number;
    public errorCode?: string;
    public innerError?: Error | string;

    constructor(code = 20, errorCode = 'Aborted', innerError?: Error | string) {
        super(`${code} ${errorCode} ${innerError}`);
        this.name = 'AbortError';
        this.message = 'Aborted';
        this.stack = innerError && (innerError as any).stack ? (innerError as any).stack : (<any>new Error()).stack;
        this.statusCode = 20;
        this.errorCode = errorCode;
        this.innerError = innerError;
    }
}
